import { gql, useMutation } from '@apollo/client';

import { GET_BROKERAGE } from './entities.brokerage.details.query';

// GraphQL mutation
const DELETE_BROKERAGE_LICENSE_MUTATION = gql`
  mutation deleteLicenseFromEntity(
    $entity_uuid: String!
    $license_uuid: String!
  ) {
    deleteLicenseFromEntity(
      entityUuid: $entity_uuid
      licenseUuid: $license_uuid
    ) {
      result
      nodesDeleted
      relationshipsDeleted
    }
  }
`;

export function DeleteBrokerageLicense() {
  const [DeleteLicenseFromEntity, { data, loading, error, reset }] =
    useMutation(DELETE_BROKERAGE_LICENSE_MUTATION, {
      refetchQueries: [GET_BROKERAGE],
      awaitRefetchQueries: true,
    });

  return {
    data,
    DeleteLicenseFromEntity,
    loading,
    error,
    reset,
  };
}
